import { CSSProperties } from "react";

export const menuDropdownStyles: { dropdown: CSSProperties } = {
	dropdown: {
		width: "auto",
		backgroundColor: "#1F2630E5",
		border: "none",
		borderRadius: 0,
		padding: 2,
		fontFamily: "TT Squares",
		fontSize: 14,
		fontWeight: 700,
		textAlign: "center",
		textTransform: "uppercase",
		zIndex: 1100
	}
};
